import { useEffect } from "react";
import { Wrench } from "lucide-react";

// Página pública neutra: no contiene enlaces ni referencias al sistema
export default function PublicPage() {
  useEffect(() => {
    document.title = "Sitio en construcción";
  }, []);
  return (
    <div className="min-h-screen app-bg flex items-center justify-center p-6" data-testid="public-page">
      <div className="panel max-w-lg w-full p-10 text-center fade-up">
        <div className="mx-auto w-14 h-14 rounded-2xl btn-neon flex items-center justify-center">
          <Wrench className="w-7 h-7" />
        </div>
        <h1 className="mt-6 text-3xl sm:text-4xl font-bold text-white" data-testid="public-title">
          Sitio en construcción
        </h1>
        <p className="mt-3 text-slate-400">Estamos trabajando en algo nuevo. Vuelva pronto.</p>
      </div>
    </div>
  );
}
